import { render, staticRenderFns } from "./TaskThreadChatForm.vue?vue&type=template&id=04909424&"
import script from "./TaskThreadChatForm.vue?vue&type=script&lang=ts&"
export * from "./TaskThreadChatForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports